import { useAddArticleQuantityMutation } from "api/administrationsApi";
import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import { getApiErrorMessage } from "../api/errorUtils";

const AddQuantityModal = ({
  modalOpen,
  toggleModal,
  updateQuantity,
  administrationSalesData,
  notificationMessage,
}) => {
  const [formData, setFormData] = useState({
    articleId: "",
    quantity: 0,
  });
  const [addArticleQuantity] = useAddArticleQuantityMutation();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async () => {
    try {
      await addArticleQuantity({
        articleId: formData.articleId,
        quantity: Number(formData.quantity),
      }).unwrap();

      updateQuantity(formData.articleId, formData.quantity);
      setFormData({ articleId: "", quantity: "" });
      toggleModal("quantity");
    } catch (error) {
      notificationMessage(
        "danger",
        getApiErrorMessage(error, "Error on updating quantity of article", {
          403: "Only company managers, admins, or owners can update article quantities.",
          404: "That administration article is no longer available in your company scope.",
        })
      );
      console.log(error);
    }
  };

  return (
    <Modal
      className="record-sale-modal"
      isOpen={modalOpen}
      toggle={toggleModal}
    >
      <ModalHeader toggle={toggleModal}>Add Quantity</ModalHeader>
      <ModalBody>
        <Form>
          <FormGroup>
            <Label for="articleId">Select Article</Label>
            <Input
              type="select"
              name="articleId"
              id="articleId"
              value={formData.articleId}
              onChange={handleInputChange}
            >
              <option value="" disabled>
                Select an article
              </option>
              {administrationSalesData.map((article) => (
                <option key={article.id} value={article.id}>
                  {article.name}
                </option>
              ))}
            </Input>
          </FormGroup>
          <FormGroup>
            <Label for="quantity">Quantity</Label>
            <Input
              type="number"
              name="quantity"
              id="quantity"
              value={formData.quantity}
              onChange={handleInputChange}
              placeholder="Enter Quantity"
            />
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={handleSubmit}>
          Save
        </Button>
        <Button color="secondary" onClick={toggleModal}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default AddQuantityModal;
